
var SiteEditMode = require('./SiteEdit').SiteEdit;
var SiteViewMode = require('./SiteView').SiteView;


export class SiteEditAndView extends React.Component {

    constructor(props) {
        super(props);

        var isEditMode = false;
        if (this.props.initialState.id === 0) {
            isEditMode = true;
        }
        this.state = {
            isEditMode: isEditMode,
            address: this.props.initialState
        };
    }

    setEditMode() {
        this.setState({
            isEditMode: true
        });
    }

    setViewMode(address) {
        this.setState({
            isEditMode: false,
            address
        });
    }

    render() {
        if (this.state.isEditMode) {
            return <SiteEditMode initialSite={this.state.address} onFinishEdit={this.setViewMode.bind(this)} />;
        }

        return <SiteViewMode initialSite={this.state.address} onSetEditMode={this.setEditMode.bind(this)} canCreateRecurringOrders={this.props.canCreateRecurringOrders}/>;
    }
}